exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*@media (max-width: 767px) {*/\r\n/* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\r\n/*.body-content {\r\n    padding-top: 50px;\r\n  }\r\n}*/\r\n\r\n#nav-container {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex-positive: 0;\r\n          flex-grow: 0;\r\n}\r\n\r\n#main {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n  padding: 0 3px 0 0;\r\n}\r\n\r\n#logo-out{\r\n    position: absolute;\r\n    top: 0;\r\n    left: -9999px;\r\n    visibility: hidden;\r\n    z-index: -10;\r\n}\r\n\r\nbody{\r\n    background-color: #FFFAFA;\r\n    padding: 0 5px;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.css
// module id = ./src/app/components/app/app.component.css
// module chunks = main